import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { DesktopAccessibilityButtons } from "./DesktopAccessibilityButtons";
import { MobileAccessibilityButtons } from "./MobileAccessibilityButtons";

export const AccessibilityButtons = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(767));

  return isMobile ? (
    <MobileAccessibilityButtons />
  ) : (
    <DesktopAccessibilityButtons />
  );
};
